import { useTranslation } from 'react-i18next';
import styles from '../InterventionGraphEditor.module.css';

interface InstanceBadgeProps {
  label: string;
  // When set, renders the colour-filled card-header variant with this fill
  // (the intervention colour); when omitted, renders the neutral chip used in
  // dependency tags and the dependency-target picker.
  backgroundColor?: string;
}

// Chip showing an intervention instance's visual identifier: a number when the
// instance is arranged, a letter when it is in the Flex pool. Renders nothing
// for an empty label. Purely visual (see
// docs/adr/0001-instance-labels-visual-only-derived).
export const InstanceBadge = ({ label, backgroundColor }: InstanceBadgeProps) => {
  const { t } = useTranslation();

  return label ? (
    <span
      className={backgroundColor ? styles.instanceHeaderBadge : styles.instanceBadge}
      style={backgroundColor ? { backgroundColor } : undefined}
      role="img"
      aria-label={t('config-instance-badge-aria', { label })}
    >
      {label}
    </span>
  ) : null;
};
